/* eslint-disable @typescript-eslint/no-explicit-any */
import Layout from '../common/components/layout/Layout';
import Header from '../common/components/layout/Header';
import AvatarImg from '../common/components/images/perfil.svg';
import Image from '../common/Image';

// assets
import ServiceCancha from '../common/components/images/home/cancha.svg';
import ServiceCamiseta from '../common/components/images/home/camiseta.svg';
import ServiceVs from '../common/components/images/home/vs.png';
import ServiceTrofeo from '../common/components/images/home/trofeo.svg';
import ServicesCardProfile from '../common/components/sections/ServicesCardProfile';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchListRegions } from '../modules/sport/actions/reducerListRegion';
import { getCommuneByRegions } from '../modules/sport/actions/reducerListCommune';
import DatePickerComponent from '../common/components/sections/DatePicker';
import Team from './Team';
import List from '../common/components/sections/List';
import {
    getSignedUrlValid,
    getUserProfile,
    updateUserProfile,
    uploadFileUrl,
} from '../modules/sport/actions/reducerProfile';
import Loading from '../common/loading/Loading';
import { IProfile, IResumen, ITeam } from '../modules/sport/interfaces/profile';
import TextFields from '../common/components/TextField/TextField';
import { getNameSports } from '../common/data/sports';
import TextFieldsPhone from '../common/components/TextField/TextFieldPhone';

//ball
import BalonFutbol from '../common/components/images/sports/futbol/balonNav.svg';
import BalonTenis from '../common/components/images/sports/tenis/balonNav.svg';
import BalonPadel from '../common/components/images/sports/padel/balonNav.svg';
import BalonBasquetbol from '../common/components/images/sports/basquetbol/balonNav.svg';

const resetError = {
    email: {
        hasError: false,
        message: '',
    },
    name: {
        hasError: false,
        message: '',
    },
    lastName: {
        hasError: false,
        message: '',
    },
    phone: {
        hasError: false,
        message: '',
    },
    gender: {
        hasError: false,
        message: '',
    },
    birthDate: {
        hasError: false,
        message: '',
    },
    address: {
        hasError: false,
        message: '',
    },
    regionId: {
        hasError: false,
        message: '',
    },
    countyId: {
        hasError: false,
        message: '',
    },
    position: {
        hasError: false,
        message: '',
    },
};

const iconBall = {
    tenis: BalonTenis,
    futbol: BalonFutbol,
    padel: BalonPadel,
    basquetbol: BalonBasquetbol,
};

const ProfileForm = (): JSX.Element => {
    const dispatch = useDispatch();
    const [error, setError] = useState(resetError);
    const [hasError, setHasError] = useState(false);
    const [errorRegister, setErrorRegister] = useState('');
    const [loandingPhoto, setLoandingPhoto] = useState<string>('false');
    const [update, setUpdate] = useState<boolean>(false);
    const [errorPhoto, setErrorPhoto] = useState<string | null>(null);
    const urlFile = process.env.REACT_APP_URL_FILE;
    const [upload, setUpload] = useState(false);

    const [values, setValues] = useState({
        name: '',
        lastName: '',
        phone: '',
        gender: '',
        birthDate: '',
        address: '',
        regionId: '',
        countyId: '',
        position: '',
        photo: '',
    });
    const genders = [
        { name: 'Masculino', value: 'MALE' },
        { name: 'Femenino', value: 'FEMALE' },
    ];
    const [communes, setCommune] = useState<Array<any>>([]);
    const [regions, setRegions] = useState<Array<any>>([]);
    const [profile, setProfile] = useState<IProfile>();
    const [resumen, setResumen] = useState<IResumen[]>([]);
    const [teams, setTeams] = useState<ITeam[]>([]);
    const [teamsAux, setTeamsAux] = useState<ITeam[]>([]);

    const selectListRegions = (state: any) => state.listRegions;
    const listRegions = useSelector(selectListRegions);

    const selectListCommunes = (state: any) => state.listCommunes;
    const listCommunes = useSelector(selectListCommunes);

    const selectProfile = (state: any) => state.profile;
    const stateProfile = useSelector(selectProfile);

    const serviceImagen = {
        ServiceCancha: ServiceCancha,
        ServiceCamiseta: ServiceCamiseta,
        ServiceVs: ServiceVs,
        ServiceTrofeo: ServiceTrofeo,
    };

    const inputRef = {
        ARRIENDA: { element: useRef<HTMLDivElement>(), percent: 0.05833 },
        INTEGRA: { element: useRef<HTMLDivElement>(), percent: 0.03618 },
        DESAFÍA: { element: useRef<HTMLDivElement>(), percent: 0.025 },
        TORNEOS: { element: useRef<HTMLDivElement>(), percent: 0.02 },
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        dispatch(fetchListRegions({}));
        dispatch(getUserProfile());
    }, []);
    /*  useEffect(() => {
        console.log('aqui teams', teams);
    }, [teams]);*/

    useEffect(() => {
        if (listRegions.data && listRegions.data.length > 0) {
            setRegions(listRegions.data);
        }
    }, [listRegions]);

    useEffect(() => {
        if (listCommunes && listCommunes.data?.data?.length > 0) {
            setCommune(listCommunes.data?.data);
        }
    }, [listCommunes]);

    useEffect(() => {
        if (update) {
            //console.log('useEffect update if:', update, stateProfile);
            dispatch(getUserProfile());
        }
        //console.log('useEffect update:', update);
    }, [update]);

    useEffect(() => {
        //console.log({ stateProfile });
        if (stateProfile && stateProfile.data?.statusCode === 'USER_PROFILE_UPDATED') {
            setUpdate(true);
        } else {
            if (stateProfile && stateProfile.data && stateProfile.data.data) {
                setUpdate(false);
                // console.log(stateProfile.data.data);
                setTeams(stateProfile.data.data.teams || []);
                setProfile(stateProfile.data.data);
                setUpload(false);
                const data = stateProfile.data.data;
                if (data.resumen) {
                    const res = data.resumen;
                    // console.log({ res });
                    setResumen(
                        res.map((r) => {
                            //console.log({ r });
                            return {
                                ...r,
                                image: serviceImagen[r.image],
                                details: r.details.map((d) => {
                                    return { ...d, sportUrl: getNameSports(d.sportId) };
                                }),
                            };
                        }),
                    );
                }
                if (data.regionId) {
                    dispatch(getCommuneByRegions({ id: data.regionId }));
                }
                setValues({
                    name: data.name,
                    lastName: data.lastName,
                    phone: data.phone,
                    gender: data.gender,
                    birthDate: data.birthDate,
                    address: data.address,
                    regionId: data.regionId,
                    countyId: data.countyId,
                    position: data.position,
                    photo: data.photo,
                });
                setTeams(data.teams);
            }
        }
    }, [stateProfile]);

    /* useEffect(() => {
        console.log('useEffect teams:', teams);
    }, [teams]);*/

    const handleRegion = async (e) => {
        e.preventDefault();
        setValues({ ...values, regionId: e.target.value });
        dispatch(getCommuneByRegions({ id: e.target.value }));
    };

    function validateForm() {
        setError(resetError);
        if (values && values.name === '') {
            setHasError(true);
            setError({
                ...resetError,
                name: {
                    hasError: true,
                    message: '¡Nombre es requerido!',
                },
            });
            return false;
        }

        if (values && values.lastName === '') {
            setHasError(true);
            setError({
                ...resetError,
                lastName: {
                    hasError: true,
                    message: '¡Apellido es requerido!',
                },
            });
            return false;
        }

        if (values && values.phone === '') {
            setHasError(true);
            setError({
                ...resetError,
                phone: {
                    hasError: true,
                    message: '¡Teléfono es requerido!',
                },
            });
            return false;
        }

        //console.log('error', error);
        return true;
    }

    function validateTeamForm() {
        const existTeam = teamsAux.filter((item) => {
            return !(
                // Verificar si la información de algún team está incompleta
                // al igual que un equipo con toda la información
                (
                    Object.prototype.hasOwnProperty.call(item, 'gender') &&
                    Object.prototype.hasOwnProperty.call(item, 'level') &&
                    item.review !== '' &&
                    item.name !== '' &&
                    item['gender'] &&
                    item['gender'] !== '' &&
                    item['level'] !== '' &&
                    item['level'] &&
                    item['color'] &&
                    item['color'] !== '' &&
                    item['color2'] &&
                    item['color2'] !== ''
                )
            );
        });

        if (existTeam.length === 4) {
            setErrorRegister('Debe completar un equipo');
            return false;
        }

        // Verificar si la información de algún team está incompleta
        for (let i = 0; i < existTeam.length; i++) {
            {
                if (
                    existTeam[i].review === '' &&
                    existTeam[i].name === '' &&
                    existTeam[i]['gender'] === '' &&
                    existTeam[i]['level'] === ''
                    //&& existTeam[i]['color'] === '' &&
                    //existTeam[i]['color2'] === ''
                ) {
                    // Si está vacía significa que no quiere rellenar esta información aún, es válido,
                } else {
                    // incompleta, es inválido
                    if (existTeam[i]['sportName']) {
                        let field = '';
                        field =
                            existTeam[i].name === ''
                                ? 'nombre del equipo'
                                : !Object.prototype.hasOwnProperty.call(existTeam[i], 'gender') ||
                                  existTeam[i]['gender'] === ''
                                ? 'sexo'
                                : !Object.prototype.hasOwnProperty.call(existTeam[i], 'level') ||
                                  existTeam[i]['level'] === ''
                                ? 'nivel'
                                : existTeam[i].review === ''
                                ? 'cuéntanos de tu equipo'
                                : existTeam[i]['color'] === ''
                                ? 'color del equipo local'
                                : existTeam[i]['color2'] === ''
                                ? 'color del equipo visitante'
                                : '';
                        setErrorRegister(
                            `Completar la información "${field}"  del equipo ${existTeam[i]['sportName']} `,
                        );

                        return false;
                    }
                }
            }
        }

        return true;
    }

    const handleUpdateProfile = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        setError(resetError);
        setErrorRegister('');
        setHasError(false);

        if (!validateForm()) {
            return;
        }
        if (!validateTeamForm()) {
            return;
        }
        // console.log('useEffect teamsAux handleUpdateProfile:', teamsAux);

        try {
            if (!hasError && values && values.phone !== '' && values.lastName !== '' && values.name !== '') {
                /* const existTeams = teamsAux.filter((item) => {
                    return (
                        item.review !== '' &&
                        item.name !== '' &&
                        item['gender'] &&
                        item['gender'] !== '' &&
                        item['level'] !== '' &&
                        item['level'] 
                        && item['color'] &&
                        item['color'] !== '' &&
                        item['color2'] &&
                        item['color2'] !== ''
                    );
                });*/
                //Setear por defecto la imagen del equipo cuando es null
                /*const teamsWithImage = teamsAux.map((item) => {
                    return {
                        ...item,
                         photo:
                            !item.photo && item.photo === null
                                ? '3bb68419-cab1-4bbb-8096-fea665eb8575.jpeg'
                                : item.photo,
                    };
                });*/
                dispatch(
                    updateUserProfile({
                        ...values,
                        teams: teamsAux,
                    }),
                );
                setError(resetError);
                setHasError(false);
            }
        } catch (error) {
            console.log({ error });
            setErrorRegister('¡No se puede registrar el perfil de usuario, intente nuevamente!');
        }
    };

    const handleChangeName = (e: any) => {
        setError({
            ...error,
            name: {
                hasError: false,
                message: '',
            },
        });
        setValues({ ...values, name: e.target.value });
    };

    const handleChangeLastName = (e: any) => {
        setError({
            ...error,
            lastName: {
                hasError: false,
                message: '',
            },
        });
        setValues({ ...values, lastName: e.target.value });
    };

    const handleChangePhone = (e: any) => {
        setError({
            ...error,
            phone: {
                hasError: false,
                message: '',
            },
        });
        setValues({ ...values, phone: e.target.value });
    };
    const handleChangePosition = (e: any) => {
        setValues({ ...values, position: e.target.value });
    };

    const handleCommune = (e) => {
        e.preventDefault();
        setValues({ ...values, countyId: e.target.value });
    };
    const handlegender = (e: any) => {
        console.log({ nonanes: e.target.value });
        setValues({ ...values, gender: e.target.value });
    };
    const handleChangeBirthDate = (value) => {
        setValues({ ...values, birthDate: value });
    };

    const uploadPhoto = async ({ target }) => {
        setUpload(true);
        const file = target.files[0];
        //console.log('file', file);
        handlerUploadFile(file, 'profile');
    };

    const handlerUploadFile = async (file: any, type: string) => {
        setErrorPhoto(null);
        const name = file.name;
        const lastDot = name.lastIndexOf('.');
        const extFile = name.substring(lastDot + 1);
        if (
            extFile !== 'jpg' &&
            extFile !== 'png' &&
            extFile !== 'jpeg' &&
            extFile !== 'gif' &&
            extFile !== 'JPG' &&
            extFile !== 'PNG' &&
            extFile !== 'JPEG' &&
            extFile !== 'GIF'
        ) {
            setLoandingPhoto('false');
            setErrorPhoto('Formato Invalido, formaro permitidos jpg, png, gif');
        } else {
            const options = {
                name: file?.name || '',
                fileType: '.' + extFile,
            };
            try {
                if (type === 'profile') {
                    setLoandingPhoto('true');
                }

                const dataSignedUrl: any = await dispatch(getSignedUrlValid(options));

                if (dataSignedUrl && dataSignedUrl.signedUrl) {
                    const statusUpload: any = await dispatch(
                        uploadFileUrl(dataSignedUrl.signedUrl, dataSignedUrl.contentType, file),
                    );
                    //console.log({ dataSignedUrl });
                    if (statusUpload === 'OK') {
                        if (type === 'profile') {
                            setValues({ ...values, photo: dataSignedUrl.key });
                        }

                        setErrorPhoto(null);
                        setLoandingPhoto('false');
                    }
                } else {
                    setErrorPhoto('Error al subir archivo vuelva Intentar');
                }
            } catch (error) {
                setLoandingPhoto('false');
                console.log('desde del form error: ', { error });
                setErrorPhoto('Error al subir archivo vuelva Intentar');
            }
        }
    };

    /* useEffect(() => {
        console.log('useEffect teamsAux externo:', teamsAux);
    }, [teamsAux]);*/

    const scrollHandler = (ref) => {
        //console.log({ ref }, inputRef[ref].element.current);
        if (inputRef[ref].element.current) {
            const coordinates = inputRef[ref].element.current.getBoundingClientRect();
            const percent = coordinates.y * inputRef[ref].percent;
            const top = coordinates.y - percent;
            // console.log('Y:', coordinates.y, 'height:', coordinates.height, 'top:', top);
            setTimeout(function () {
                window.scrollTo({ top: top, behavior: 'smooth' });
            }, 300);
        }
    };

    return (
        <Layout navProps={{ title: 'Perfil | Supermatch', description: 'Perfil Supermatch' }}>
            <>
                <Header />

                {stateProfile && stateProfile.isLoading ? (
                    <div className={'min-h-layout'}>
                        {' '}
                        <Loading />
                    </div>
                ) : stateProfile && stateProfile.error ? (
                    <div className="flex items-center justify-center lg:h-96 mb:h-96 min-h-layout">
                        <p className="text-2xl text-sm-blue-primary">
                            El Servicio no está Disponible en estos momentos
                        </p>
                    </div>
                ) : (
                    profile && (
                        <div key={'profile-form'} className={`bg-white pt-24  pb-5  min-h-layout container mx-auto`}>
                            <div className={`flex-col pt-4 `}>
                                <div className="flex items-center justify-center w-full ">
                                    <label
                                        className={`flex flex-col w-full  ${
                                            values && values.photo == '' ? 'h-48' : 'h-40'
                                        } hover:bg-gray-100 hover:border-gray-300 cursor-pointer`}
                                    >
                                        <div className="flex flex-col items-center justify-center pt-7">
                                            <Image
                                                src={
                                                    profile.imagePath ? profile.imagePath : upload ? urlFile : AvatarImg
                                                }
                                                alt={'profile'}
                                                height={119}
                                                width={119}
                                                imgClassName={'rounded-full border-4 border-sm-blue-primary '}
                                            />
                                            {loandingPhoto === 'true' ? (
                                                <p className="absolute z-30 top-28 text-xs text-sm-blue-primary ">
                                                    Cargando Logo...
                                                </p>
                                            ) : (
                                                values &&
                                                values.photo == '' && (
                                                    <p className="text-xl font-bold italic   pt-1  tracking-wider text-gray-400 group-hover:text-gray-600">
                                                        Selecciona una foto
                                                    </p>
                                                )
                                            )}
                                        </div>
                                        <input
                                            accept="image/*"
                                            className={'opacity-0  '}
                                            id="button-photo-capture"
                                            onChange={uploadPhoto}
                                            type="file"
                                        />
                                    </label>
                                </div>
                                {errorPhoto && <p className="text-sm text-red-400 text-center">{errorPhoto}</p>}
                                <p className="text-center text-xl font-bold italic text-sm-blue-primary pt-0 pb-1">
                                    Mi Supermatch
                                </p>
                            </div>
                            {/*<div className={`flex-col`}>
                                <p className="text-center text-base  text-sm-blue-primary pt-1 pb-4">
                                    {profile.name} {profile.lastName}
                                </p>
                                                </div>*/}

                            <div className={`flex-col  `} id="profile">
                                <section
                                    className="relative  flex-none md:flex w-full justify-center content-center items-center text-center pt-5"
                                    role="attributes sports"
                                >
                                    {resumen &&
                                        resumen.length > 0 &&
                                        resumen.map((s, i) => (
                                            <div key={`card-service-profile-${i}`}>
                                                <ServicesCardProfile service={s} i={i} scrollHandler={scrollHandler} />
                                            </div>
                                        ))}
                                </section>
                                {true && (
                                    <>
                                        {teams && teams.length > 0 && (
                                            <div className={`flex-col`}>
                                                <p className="text-center text-xl text-sm-blue-primary pt-4 pb-4 font-bold italic ">
                                                    Mis Equipos
                                                </p>
                                            </div>
                                        )}
                                        <section
                                            className="flex flex-col md:flex-row w-full justify-center content-center"
                                            role="team sports"
                                        >
                                            {teams &&
                                                teams.length > 0 &&
                                                teams.map((t, i) => (
                                                    <div key={`card-service-sport-profile-${i}`}>
                                                        <div
                                                            className="mx-auto md:mx-2 w-full md:w-72 bg-white flex flex-col justify-center items-center rounded-lg py-1 mb-1 md:mb-0 border-2 border-gray-200 shadow-profile"
                                                            key={`ServicesCardProfile-${Math.random()
                                                                .toString(36)
                                                                .substr(2, 9)}-${i}`}
                                                        >
                                                            <Team
                                                                teamOri={t}
                                                                iconSport={iconBall[t.sportSlug]}
                                                                index={i}
                                                                urlFile={urlFile}
                                                                setTeamsAux={setTeamsAux}
                                                                teams={teams}
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                        </section>
                                    </>
                                )}
                                <div className={`flex-col`}>
                                    <p className="text-center text-base  text-sm-blue-primary pt-4 pb-1 font-bold italic ">
                                        Mi Datos
                                    </p>
                                    <p className="text-center text-base  text-sm-blue-primary pt-1 pb-4 font-bold italic ">
                                        {profile.email && profile.email}
                                    </p>
                                </div>
                                <div className="flex-none md:flex w-full  bg-white  justify-center content-center items-center text-center">
                                    {values && (
                                        <form
                                            className="flex sm:w-1/3 md:w-1/2 flex-col mb-2 p-4 sm:p-0"
                                            onSubmit={handleUpdateProfile}
                                        >
                                            <>
                                                <TextFields
                                                    autoFocus={false}
                                                    name={'name'}
                                                    id={'name'}
                                                    path={
                                                        'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                                                    }
                                                    label={'Nombre'}
                                                    type={'text'}
                                                    value={values.name}
                                                    placeholder={'Nombre'}
                                                    hasError={error.name.hasError}
                                                    messageError={error.name.message}
                                                    background={'light'}
                                                    onChange={handleChangeName}
                                                />
                                                <TextFields
                                                    name={'lastName'}
                                                    id={'lastName'}
                                                    path={
                                                        'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                                                    }
                                                    label={'Apellido'}
                                                    type={'text'}
                                                    value={values.lastName}
                                                    placeholder={'Apellido'}
                                                    hasError={error.lastName.hasError}
                                                    messageError={error.lastName.message}
                                                    background={'light'}
                                                    onChange={handleChangeLastName}
                                                />
                                                <TextFieldsPhone
                                                    name={'phone'}
                                                    id={'phone'}
                                                    path={
                                                        'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                                                    }
                                                    label={'Teléfono  +56 9 9999 9999'}
                                                    value={values.phone}
                                                    placeholder={'Teléfono'}
                                                    hasError={error.phone.hasError}
                                                    messageError={error.phone.message}
                                                    onChange={handleChangePhone}
                                                    background={'light'}
                                                />
                                                <TextFields
                                                    name={'phone'}
                                                    id={'position'}
                                                    path={
                                                        'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                                                    }
                                                    label={'Posición en la cancha'}
                                                    type={'text'}
                                                    value={values.position}
                                                    placeholder={'Posición en la cancha'}
                                                    hasError={error.position.hasError}
                                                    messageError={error.position.message}
                                                    background={'light'}
                                                    onChange={handleChangePosition}
                                                />
                                                <div className="relative pt-2 mt-4">
                                                    <label
                                                        htmlFor="birthDate"
                                                        className="font-semibold pl-2 pointer-events-none absolute left-0 -top-3.5 text-sm-blue-primary text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                                                    >
                                                        selecciona tu fecha de Nacimiento
                                                    </label>
                                                    <DatePickerComponent
                                                        birthDateProfile={values.birthDate}
                                                        handleChangeBirthDate={handleChangeBirthDate}
                                                    />
                                                </div>

                                                <label className="relative text-gray-400 focus-within:text-gray-600 block pt-2 mt-4">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="pointer-events-none w-8 h-8 absolute top-1/2 transform -translate-y-1/2 pb-1 right-3"
                                                        viewBox="0 0 20 20"
                                                        fill="currentColor"
                                                    >
                                                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                                    </svg>
                                                    <label
                                                        htmlFor="address"
                                                        className="font-semibold pl-2 pointer-events-none absolute left-0 -top-3.5 text-sm-blue-primary text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                                                    >
                                                        Dirección
                                                    </label>
                                                </label>
                                                <label className="relative text-gray-400 focus-within:text-gray-600 block pt-2 mt-4">
                                                    <label
                                                        htmlFor="gender"
                                                        className="font-semibold  pl-2 pointer-events-none absolute left-0 -top-3.5 text-sm-blue-primary text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                                                    >
                                                        Sexo
                                                    </label>
                                                    <select
                                                        className={`${
                                                            error.gender.hasError
                                                                ? 'border-red-600 shadow-error'
                                                                : values.gender
                                                                ? 'border-gray-300'
                                                                : 'border-gray-300'
                                                        } w-full mb-2 py-3 p-4  h-14 bg-white border-2  rounded-xl text-left shadow-profile`}
                                                        name="gender"
                                                        value={values.gender}
                                                        onChange={handlegender}
                                                        disabled={genders && genders.length > 0 ? false : true}
                                                    >
                                                        <option className="text-sm-gray-1" value="">
                                                            Sexo
                                                        </option>
                                                        {genders &&
                                                            genders.length > 0 &&
                                                            genders.map((r, i) => (
                                                                <option value={r.value} key={`gender-${i}`}>
                                                                    {r.name}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </label>
                                                <label className="relative text-gray-400 focus-within:text-gray-600 block pt-2 mt-4">
                                                    <label
                                                        htmlFor="regionId"
                                                        className="font-semibold pl-2 pointer-events-none absolute left-0 -top-3.5 text-sm-blue-primary text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                                                    >
                                                        Región
                                                    </label>
                                                    <select
                                                        className={`${
                                                            error.regionId.hasError
                                                                ? 'border-red-600 shadow-error'
                                                                : values.regionId
                                                                ? 'border-gray-300'
                                                                : 'border-gray-300'
                                                        } w-full mb-2 py-3 p-4  h-14 bg-white border-2  rounded-xl text-left shadow-profile`}
                                                        name="regionId"
                                                        onChange={handleRegion}
                                                        value={values.regionId}
                                                        disabled={regions && regions.length > 0 ? false : true}
                                                    >
                                                        <option className="text-sm-gray-1" value="">
                                                            Región
                                                        </option>
                                                        {regions &&
                                                            regions.length > 0 &&
                                                            regions.map((r, i) => (
                                                                <option value={r.id} key={`regionId-${i}`}>
                                                                    {r.name}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </label>
                                                <label className="relative text-gray-400 focus-within:text-gray-600 block pt-2 mt-4">
                                                    <label
                                                        htmlFor="countyId"
                                                        className="font-semibold pl-2 pointer-events-none absolute left-0 -top-3.5 text-sm-blue-primary text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                                                    >
                                                        Comuna
                                                    </label>
                                                    <select
                                                        className={`${
                                                            error.countyId.hasError
                                                                ? 'border-red-600 shadow-error'
                                                                : values.countyId
                                                                ? 'border-gray-300'
                                                                : 'border-gray-300'
                                                        } w-full mb-2 py-3 p-4  h-14 bg-white border-2  rounded-xl text-left shadow-profile`}
                                                        name="countyId"
                                                        onChange={handleCommune}
                                                        disabled={
                                                            (communes && communes.length > 0) || values.regionId
                                                                ? false
                                                                : true
                                                        }
                                                        value={values.countyId}
                                                    >
                                                        <option className="text-sm-gray-1" value="">
                                                            Comuna
                                                        </option>
                                                        {communes &&
                                                            communes.length > 0 &&
                                                            communes.map((countyId) => (
                                                                <option
                                                                    value={countyId.id}
                                                                    key={`countyId-${countyId.id}`}
                                                                >
                                                                    {countyId.name}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </label>
                                            </>

                                            {errorRegister && (
                                                <p className="mb-6 text-base text-red-200">{errorRegister}</p>
                                            )}
                                            <button
                                                type="submit"
                                                className="w-full text-white px-4 py-4 rounded-lg text-lg mb-6 bg-sm-integrate"
                                            >
                                                Guardar
                                            </button>
                                        </form>
                                    )}
                                </div>{' '}
                                {resumen &&
                                    resumen.length > 0 &&
                                    resumen.map(
                                        (s, i) =>
                                            s.details &&
                                            s.details.length > 0 && (
                                                <div key={`title-${s.title}-${i}`} ref={inputRef[s.alt].element}>
                                                    <div className={`flex-col`}></div>
                                                    <div className={`flex-col`} key={`table-content-${i}`}>
                                                        <div className="text-center text-base  text-sm-blue-primary font-bold italic border-2 mb-8 ">
                                                            <div className="text-center text-base  text-sm-blue-primary pt-4 pb-4 font-bold italic bg-gray-200 ">
                                                                Listado de {s.title}
                                                            </div>
                                                            <div className="flex-none md:flex w-full bg-white  justify-center content-center items-center text-center border-gray-200 rounded overflow-x-auto">
                                                                <List details={s.details} type={s.type} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ),
                                    )}
                            </div>
                        </div>
                    )
                )}
            </>
        </Layout>
    );
};

export default ProfileForm;
